import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=263e631c&scoped=true&"
import script from "./Sponsors.vue?vue&type=script&lang=js&"
export * from "./Sponsors.vue?vue&type=script&lang=js&"
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=263e631c&scoped=true&lang=scss&"
import style1 from "./Sponsors.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e631c",
  null
  
)

component.options.__file = "Sponsors.vue"
export default component.exports